/** @jsx jsx */
import { Flex, Label } from '@bottlebooks/gatsby-design-system';
import { jsx } from 'theme-ui';

export default function Badge({ icon, children, className }) {
  return (
    <Flex sx={{ alignItems: 'center' }} className={className}>
      {icon}
      <Label sx={{ paddingX: 2 }}>{children}</Label>
    </Flex>
  );
}
